import { render } from "./gateway.vue?vue&type=template&id=2ff35e25"
import script from "./gateway.vue?vue&type=script&lang=js"
export * from "./gateway.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__